<div class="bill-list-wrapper">
  <div id="header-wrapper">
    <msd-period-bar (onPeriod)="onPeriodFilter($event)"></msd-period-bar>

    <div>
      <button class="btn btn-outline btn-outline-primary" (click)="export()">
        Exporter
      </button>
    </div>
  </div>

  <div class="append-loader" *ngIf="isAppendLoading">
    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    <span class="ml10px">Chargement...</span>
  </div>

  <table *ngIf="billParams" class="table header">
    <thead>
    <tr>
      <th id="reference" scope="col">Référence</th>
      <th id="fullname" scope="col">Nom du patient/tiers</th>
      <th id="date" scope="col">Date</th>
      <th id="amount-excl" scope="col">{{billParams.tax === 'with' ? 'Mont. HT': 'Montant'}}</th>
      <th *ngIf="billParams.tax === 'with'" id="amount-incl" scope="col">Mont. TTC</th>
      <th id="actions" scope="col">Actions</th>
    </tr>
    </thead>
  </table>
  <div (scrolled)="onScroll()"
       *ngIf="billParams"
       [scrollWindow]="false"
       id="bill-list-wrapper"
       infiniteScroll>
    <ng-container
      *ngIf="
        !isOnError && !isLoading && creditList && creditList.length > 0;
        else innerLoading
      "
    >
      <table class="table body">
        <tbody>
        <tr
          (onClick)="view(credit)"
          (onRestore)="restore(credit)"
          (onDownload)="download(credit)"
          (onPrint)="print(credit)"
          *ngFor="let credit of creditList"
          [credit]="credit"
          [facade]="facade"
          [tax]="billParams.tax"
          msd-credit-row>
        </tr>
        </tbody>
      </table>
    </ng-container>
    <ng-template #innerLoading>
      <ngx-inner-loading
        class="flex-center"
        [empty]="creditList?.length === 0"
        [error]="isOnError"
        [loading]="isLoading"
        (retry)="loadPage(0)"
        [loadingDescription]="'Chargement...'"
        [emptyDescription]="'Aucune avoir archivé !'"
        [errorDescription]="'Une erreur est survenue. Veuillez réessayer plus tard.'"
        [retryButtonText]="'Réessayer'">
      </ngx-inner-loading>
    </ng-template>
  </div>
  <table *ngIf="billParams" class="table footer">
    <tfoot>
    <tr>
      <td id="count">{{countCredit()}}</td>
      <td id="empty-1"></td>
      <td id="tot-amount-excl">{{totalExclCredit()}}€</td>
      <td *ngIf="billParams.tax === 'with'" id="tot-amount-incl">{{totalInclCredit()}}€</td>
      <td id="empty-2"></td>
    </tr>
    </tfoot>
  </table>

</div>
